import React from 'react';
import { StatusAborted, StatusOK, StatusError, StatusRunning } from '@backstage/core-components';
import { StageExecutionStatus } from '@aws-sdk/client-codepipeline';

const PipelineStageStatus = ({
  status
}) => {
  switch (status) {
    case StageExecutionStatus.InProgress:
      return /* @__PURE__ */ React.createElement(StatusRunning, null, "In progress");
    case StageExecutionStatus.Failed:
      return /* @__PURE__ */ React.createElement(StatusError, null, "Failed");
    case StageExecutionStatus.Cancelled:
      return /* @__PURE__ */ React.createElement(StatusAborted, null, "Cancelled");
    case StageExecutionStatus.Stopped:
      return /* @__PURE__ */ React.createElement(StatusAborted, null, "Stopped");
    case StageExecutionStatus.Stopping:
      return /* @__PURE__ */ React.createElement(StatusAborted, null, "Stopping");
    case StageExecutionStatus.Succeeded:
      return /* @__PURE__ */ React.createElement(StatusOK, null, "Succeeded");
    default:
      return /* @__PURE__ */ React.createElement(StatusAborted, null, "Unknown");
  }
};

export { PipelineStageStatus };
//# sourceMappingURL=PipelineStageStatus.esm.js.map
